import {
  Button,
  Typography,
  Box,
  Modal,
  Tooltip,
  IconButton,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
} from '@mui/material';
import { Storage } from 'aws-amplify';
import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import { mechanicSpecificExport } from '../../../graphql/queries';
import { Notification } from '../../../common/Notification/Notification';
import { DialogBox } from './../../../common/Dialog/DialogBox';
import { notificationType } from '../../../types/notifications';
import { useState } from 'react';
import moment from 'moment';
import { API } from 'aws-amplify';
import { BatchExportState } from './ManageLuckyNumbersExport';



interface ExportManagerModalProps {
  inputProofType?: string;
  inputConfigurationId: string;
  exportInProgress: boolean;
  inputBatchId: string;
  setExports: React.Dispatch<React.SetStateAction<BatchExportState>>;
  modalOpen: boolean;
  handleCloseModal: () => void;
  inputBatchOrder: number;
  exports: { key: string; url: string }[];
  handleDownload: (url: string) => void;
}

const ExportManagerModal = ({inputProofType, inputConfigurationId, inputBatchId, modalOpen, handleCloseModal, inputBatchOrder, exports, handleDownload, exportInProgress, setExports}: ExportManagerModalProps): JSX.Element => {
    const [deletionDialogOpen, setDeletionDialogOpen] = useState(false);
    const [selectedKey, setSelectedKey] = useState<string | null>(null);
    const [notificationState, setNotificationState] = useState<notificationType>({
    open: false,
    title: '',
    content: ''
});


    const prefix = `dataExporter/mechanicSpecificExports/${inputConfigurationId}#${inputBatchId}/completedExports/`;

const handleDelete = async (key: string) => {
  try {
    await Storage.remove(key, { level: 'public' });
    setExports(prev => {
      const batch = prev[inputBatchId];
      if (!batch) return prev;
      const updatedExports = batch.perBatchExports.filter(file => file.key !== key);
      return {
        ...prev,
        [inputBatchId]: { ...batch, perBatchExports: updatedExports }
      };
    });
    setNotificationState({ open: true, title: 'Export deleted successfully!', content: '', level: 'success' });
  } catch (error) {
    setNotificationState({ open: true, title: 'Error deleting export!', content: '', level: 'error' });
    console.error('Error deleting export:', error);
  }
};

    const generateExportForBatch = async () => {
        setNotificationState({
                    open: true,
                    title: 'Export generation initiated successfully!',
                    content: '',
                    level: 'success'
                });
            setExports(prev => ({
                        ...prev,
                        [inputBatchId]: { inProgress: true, perBatchExports: [...exports] }
                        }));
            try {
                const result: any = await API.graphql({
                        query: mechanicSpecificExport,
                        variables: {
                        mechanicSpecificExportLambdaInput: {
                            body: {
                                proofType: inputProofType,
                                configurationId: inputConfigurationId,
                                batchId: inputBatchId
                            }
                        }
                    }
    });
                console.log('Export generation initiated:', result);

                return result;
            } catch (error) {
                setNotificationState({
                    open: true,
                    title: 'Error initiating generating export!',
                    content: '',
                    level: 'error'
                });
                console.error('Error generating export:', error);
            }
        }
    return (
        <Modal open={modalOpen} onClose={handleCloseModal}>
            <>
            <Notification
                notificationState={notificationState}
                setNotificationState={setNotificationState}
                messageVisibilityTime={1500}
            />
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            minWidth: 300,
            borderRadius: 2,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            alignItems: 'center',
          }}
        >
          <Typography variant="h6" sx={{ mb: 2 }}>
            Export Lucky Number Winners for Batch {inputBatchOrder}
          </Typography>
           <TableContainer component={Paper}>
      <Table sx={{ minWidth: 500 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Export Date</TableCell>
            <TableCell align="right">Download</TableCell>
            <TableCell align="right">Delete</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {exports.slice(0, 5).map((file, idx) => {
            const fileName = file.key.replace(prefix, '');
            const timestampMatch = fileName.match(/^(\d+)_winners_export\.csv$/);
            let formattedDate = '';
            if (timestampMatch) {
              formattedDate = moment(Number(timestampMatch[1])).format('YYYY-MM-DD HH:mm:ss');
            }
            return (
              <TableRow key={idx} >
                <TableCell>
                  <Typography variant="subtitle2" sx={{ color: '#057030ff', paddingRight: '5px' }}>
                    {formattedDate ? formattedDate : fileName}
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <IconButton>
                    <DownloadIcon onClick={() => handleDownload(file.url)} />
                  </IconButton>
                </TableCell>
                <TableCell align="right">
                  <IconButton>
                    <DeleteIcon  onClick={() => {
                 setSelectedKey(file.key);
              setDeletionDialogOpen(true);
            }} />
                  </IconButton>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
          <Tooltip
            title={exports.length >= 5 ? 'There are 5 exports. Please delete one to generate a new export.' : ''}
            arrow
            placement="top"
          >
            <span style={{ width: '100%' }}>
              <Button
                variant="contained"
                color="primary"
                sx={{
                  width: '100%',
                  bgcolor: exports.length >= 5 ? 'grey.300' : undefined,
                  color: exports.length >= 5 ? 'grey.700' : undefined,
                }}
                onClick={() => generateExportForBatch()}
                disabled={exports.length >= 5 || exportInProgress}
              >
                Generate New Export
              </Button>
            </span>
          </Tooltip>
          <Button
            variant="text"
            color="primary"
            sx={{
              width: '100%',
              bgcolor: exports.length >= 5 ? 'grey.300' : undefined,
              color: exports.length >= 5 ? 'grey.700' : undefined,
            }}
            onClick={handleCloseModal}
          >
            Close
          </Button>
        </Box>
        <DialogBox
            dialogContent={'This will permanently delete the export file. Are you sure you want to proceed?'}
            isOpen={deletionDialogOpen}
            dialogCloseHandler={() => setDeletionDialogOpen(false)}
            actionButtonLabels={['CANCEL', 'DELETE']}
            actionButtonHandlers={[() => setDeletionDialogOpen(false), () => { setDeletionDialogOpen(false); handleDelete(selectedKey); }]}
        />
        </>
      </Modal>
    )
}

export { ExportManagerModal };
